import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

/**
 * App-wide notifications about workorder orderlines that are added outside the orderlines list
 * component itself — e.g. a line added via the barcode-scanner action sheet's "Toevoegen &
 * Doorgaan" / "Aanmaken & Doorgaan". The orderlines list subscribes and refreshes so newly added
 * lines appear without a manual pull-to-refresh. See TEN-22397.
 */
@Injectable({ providedIn: "root" })
export class WorkorderLineEventService {
	private orderLineAddedSource = new Subject<void>();
	orderLineAdded$: Observable<void> = this.orderLineAddedSource.asObservable();

	notifyOrderLineAdded() {
		this.orderLineAddedSource.next();
	}
}
